module.exports = __webpack_public_path__ + "6b28efdddf4e48ae5835a28a9e4ac2f7.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/whats-new.html
// module id = 2307
// module chunks = 0